import { useState } from 'react';
import About from './pages/About';
import Contact from './pages/Contact';
import Resume from './pages/Resume';
import Engineering from './pages/Engineering';
import WebDevelopment from './pages/WebDevelopment';
import Stylophone from './pages/Stylophone';
import Header from './Header';
import Footer from './Footer';

export default function PortfolioContainer() {
  // Defaulting to 'Work' as home page? What does the parameter mean? delete
  const [currentPage, setCurrentPage] = useState('About');

  // Return corresponding page component depending on value of currentPage
  const renderPage = () => {
    if (currentPage === 'WebDevelopment') {
      return <WebDevelopment />;
    } else if (currentPage === 'Engineering') {
      return <Engineering handlePageChange={handlePageChange} />;
    } else if (currentPage === 'Stylophone') {
      return <Stylophone handlePageChange={handlePageChange} />;
    } else if (currentPage === 'About') {
      return <About avatar='./assets/avatar.jpeg' />;
    } else if (currentPage === 'Resume') {
      return <Resume />;
    } else {
      return <Contact />;
    }
  };

  const handlePageChange = (page) => setCurrentPage(page);

  return (
    <div id='flex-parent'>
      <Header handlePageChange={handlePageChange} />
      <main className='color-secondary'>{renderPage()}</main>
      <Footer />
    </div>
  );
}
